export type MovieType = 'movie' | 'tv' | 'variety';

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  year: number;
  region: string;
  rating: number;
  popularity: number;
  director: string;
  cast: string[];
  genres: string[];
  episodes: string;
  status: string;
  summary: string;
  poster: string;
  backdrop: string;
  updatedAt: string;
}

export const typeLabels: Record<MovieType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const movies: Movie[] = [
  {
    id: 'night-train-to-mars',
    title: '夜行列车去火星',
    type: 'movie',
    year: 2025,
    region: '国产',
    rating: 8.7,
    popularity: 98,
    director: '陆知白',
    cast: ['沈砚舟', '温以宁', '梁峻'],
    genres: ['科幻', '剧情', '悬疑'],
    episodes: '136 分钟',
    status: '已上线',
    summary:
      '一列穿越荒原的夜行列车里，十二位互不相识的乘客被同一个梦境牵引。天文工程师、失眠的钢琴师与一名不肯透露姓名的少年，在氧气逐渐稀薄的旅程中，各自触碰着关于远方的执念。当列车驶入最后的隧道，他们必须决定：是留在熟悉的站台，还是继续向着那颗从不回答的星球前进。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20night%20train%20crossing%20a%20desert%20under%20a%20huge%20orange%20planet%2C%20deep%20charcoal%20sky%2C%20warm%20amber%20light%20spilling%20from%20windows%2C%20minimalist%20commercial%20poster%20design%2C%20high%20detail%2C%20artistic%20photography&width=600&height=840&seq=sigua-poster-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20scene%20of%20a%20lone%20night%20train%20crossing%20a%20vast%20dark%20desert%20beneath%20a%20giant%20orange%20glowing%20planet%2C%20amber%20headlights%20cutting%20through%20mist%2C%20moody%20atmospheric%20film%20still%2C%20high%20detail&width=1600&height=900&seq=sigua-back-01&orientation=landscape',
    updatedAt: '2026-10-16',
  },
  {
    id: 'oranges-in-the-snow',
    title: '雪地里的橙子',
    type: 'tv',
    year: 2026,
    region: '国产',
    rating: 9.1,
    popularity: 96,
    director: '周牧野',
    cast: ['苏黎', '陈屿白', '许安'],
    genres: ['家庭', '剧情'],
    episodes: '全 24 集',
    status: '更新至 18 集',
    summary:
      '北方小城的一间旧杂货店，在三十年里见证了一家人的离散与重聚。母亲每天都会把一只橙子摆在窗台，等那个始终没回来的孩子。当小女儿带着自己的秘密回到雪国，她发现窗台上已经堆满了橙子，也堆满了无人说出口的等待。',
    poster:
      'https://readdy.ai/api/search-image?query=Emotional%20tv%20series%20poster%20of%20a%20small%20snowy%20northern%20town%20with%20an%20old%20grocery%20store%20window%20and%20glowing%20warm%20lamp%2C%20single%20orange%20fruit%20on%20the%20windowsill%2C%20snowflakes%2C%20soft%20melancholic%20light%2C%20minimal%20poster%20composition&width=600&height=840&seq=sigua-poster-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Snowy%20northern%20chinese%20small%20town%20at%20dusk%20with%20a%20small%20old%20grocery%20store%2C%20warm%20amber%20glow%20from%20windows%20against%20cold%20white%20snow%2C%20cinematic%20film%20still%2C%20quiet%20nostalgic%20atmosphere&width=1600&height=900&seq=sigua-back-02&orientation=landscape',
    updatedAt: '2026-10-15',
  },
  {
    id: 'slow-variety-kitchen',
    title: '慢一点厨房',
    type: 'variety',
    year: 2026,
    region: '国产',
    rating: 8.4,
    popularity: 91,
    director: '林一川',
    cast: ['何嘉木', '蓝小满', '阮青'],
    genres: ['美食', '真人秀'],
    episodes: '全 12 期',
    status: '更新至 9 期',
    summary:
      '三位性格迥异的常驻嘉宾把一间山间小院改成开放式厨房，每期只做一道菜，却要花上一整天。从挑选食材的清晨集市，到炉火渐弱的黄昏，节目用最慢的节奏，讲最热闹的人间烟火。',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20variety%20show%20poster%20of%20a%20rustic%20mountain%20courtyard%20open%20kitchen%20at%20golden%20hour%2C%20wooden%20table%20with%20fresh%20vegetables%20and%20steaming%20pot%2C%20orange%20sunlight%2C%20cozy%20friendly%20mood%2C%20clean%20poster%20layout&width=600&height=840&seq=sigua-poster-03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rustic%20courtyard%20kitchen%20in%20mountains%20at%20golden%20hour%20with%20wooden%20table%2C%20steaming%20dishes%2C%20hanging%20herbs%2C%20warm%20orange%20sunlight%20and%20soft%20bokeh%2C%20cinematic%20food%20lifestyle%20photography&width=1600&height=900&seq=sigua-back-03&orientation=landscape',
    updatedAt: '2026-10-14',
  },
  {
    id: 'seven-signals',
    title: '第七信号',
    type: 'tv',
    year: 2025,
    region: '国产',
    rating: 8.9,
    popularity: 94,
    director: '顾澜',
    cast: ['陆时行', '夏未岚', '程野'],
    genres: ['悬疑', '犯罪'],
    episodes: '全 16 集',
    status: '完结',
    summary:
      '一座沿海城市每隔七年会出现一次奇怪的电波干扰，而每次干扰后都会有一桩悬案被重新翻开。年轻的声学研究员与即将退休的刑警搭档，沿着七段被篡改的录音，一路追到城市最安静的那片海。',
    poster:
      'https://readdy.ai/api/search-image?query=Mystery%20crime%20series%20poster%20of%20a%20coastal%20city%20at%20night%20with%20radio%20wave%20light%20and%20lighthouse%20beam%2C%20dark%20charcoal%20tones%20with%20amber%20accents%2C%20tense%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Coastal%20city%20at%20night%20glowing%20with%20rain%2C%20lighthouse%20beam%20sweeping%20over%20dark%20sea%2C%20amber%20streetlight%20reflections%2C%20cinematic%20thriller%20film%20still%2C%20high%20detail&width=1600&height=900&seq=sigua-back-04&orientation=landscape',
    updatedAt: '2026-10-13',
  },
  {
    id: 'summer-post-office',
    title: '夏天的邮局',
    type: 'movie',
    year: 2024,
    region: '国产',
    rating: 8.2,
    popularity: 86,
    director: '唐予安',
    cast: ['祝星野', '南枝', '邵川'],
    genres: ['爱情', '剧情'],
    episodes: '112 分钟',
    status: '已上线',
    summary:
      '小镇上唯一一家邮局即将关闭，负责投递的年轻人决定亲手把三十年来无人领取的信件送到收信人手中。最后一封没有地址的信，写给了邮局自己。在这个被海风吹了一个夏天的故事里，告别与重逢共用同一张邮票。',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20summer%20movie%20poster%20of%20a%20small%20seaside%20post%20office%20with%20blue%20shutter%20and%20orange%20awning%2C%20stack%20of%20old%20letters%2C%20warm%20sunlight%20and%20palm%20leaves%20shadow%2C%20soft%20nostalgic%20tone%2C%20minimal%20layout&width=600&height=840&seq=sigua-poster-05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Seaside%20small%20town%20post%20office%20in%20summer%20afternoon%20light%2C%20warm%20orange%20awning%2C%20bicycle%20and%20letters%2C%20gentle%20sea%20breeze%2C%20cinematic%20film%20still%20with%20soft%20warm%20tones&width=1600&height=900&seq=sigua-back-05&orientation=landscape',
    updatedAt: '2026-10-12',
  },
  {
    id: 'island-debate-club',
    title: '海岛辩论社',
    type: 'variety',
    year: 2026,
    region: '国产',
    rating: 8.6,
    popularity: 89,
    director: '方知夏',
    cast: ['齐远', '白露', '沈禾'],
    genres: ['竞技', '治愈'],
    episodes: '全 10 期',
    status: '更新至 6 期',
    summary:
      '十二位年轻人在一座没有信号的岛上组成两个辩论社，每期围绕一个生活里的小问题展开讨论：该不该为爱好花钱、离开家乡算不算失败。海风把答案吹散，也把彼此的话送到了更远的地方。',
    poster:
      'https://readdy.ai/api/search-image?query=Outdoor%20reality%20show%20poster%20of%20young%20people%20having%20a%20debate%20on%20a%20sunny%20island%20cliff%2C%20white%20wooden%20stage%2C%20ocean%20backdrop%2C%20warm%20golden%20light%2C%20fresh%20energetic%20poster%20design&width=600&height=840&seq=sigua-poster-06&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sunny%20island%20cliff%20with%20young%20people%20gathered%20for%20an%20outdoor%20debate%2C%20turquoise%20sea%20and%20warm%20golden%20sunset%2C%20cinematic%20lifestyle%20photography%2C%20airy%20breezy%20mood&width=1600&height=900&seq=sigua-back-06&orientation=landscape',
    updatedAt: '2026-10-11',
  },
  {
    id: 'paper-crane-hour',
    title: '纸鹤时刻',
    type: 'movie',
    year: 2025,
    region: '国产',
    rating: 8.8,
    popularity: 92,
    director: '谢南舟',
    cast: ['晏清', '纪川', '罗杉'],
    genres: ['动画', '奇幻'],
    episodes: '98 分钟',
    status: '已上线',
    summary:
      '一台老旧的手风琴在深夜开始生长，把整座城市折成一只纸鹤。为了把城市还原成原来的样子，一个不会折纸的小女孩必须在一夜之间学会九百九十九种折法。这是一部关于记忆与手的温度的奇幻动画长片。',
    poster:
      'https://readdy.ai/api/search-image?query=Artistic%20animated%20film%20poster%20of%20a%20city%20folding%20into%20a%20giant%20paper%20crane%2C%20paper%20texture%20surfaces%2C%20warm%20cream%20and%20orange%20palette%2C%20dreamy%20minimal%20poster%20design%2C%20high%20detail%20illustration&width=600&height=840&seq=sigua-poster-07&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Surreal%20animated%20scene%20of%20a%20city%20folding%20itself%20into%20paper%20cranes%20under%20a%20warm%20amber%20sky%2C%20layered%20paper%20textures%2C%20dreamlike%20artistic%20cinematic%20frame&width=1600&height=900&seq=sigua-back-07&orientation=landscape',
    updatedAt: '2026-10-10',
  },
  {
    id: 'the-longest-lunch',
    title: '最长的午饭',
    type: 'tv',
    year: 2024,
    region: '国产',
    rating: 8.0,
    popularity: 82,
    director: '何孟然',
    cast: ['廖嘉', '费晓', '杜衡'],
    genres: ['喜剧', '职场'],
    episodes: '全 20 集',
    status: '完结',
    summary:
      '一家广告公司把午饭时间延长到了三个小时，从此每个中午都变成了一场没有硝烟的谈判。三个不同部门的小职员在这间食堂里结下同盟，也在这间食堂里慢慢变成了自己曾经讨厌的大人。',
    poster:
      'https://readdy.ai/api/search-image?query=Comedy%20series%20poster%20of%20a%20bright%20office%20canteen%20table%20with%20lunch%20boxes%20and%20a%20sliced%20orange%2C%20playful%20warm%20colors%2C%20clean%20modern%20poster%20design%2C%20cheerful%20mood&width=600&height=840&seq=sigua-poster-08&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Bright%20modern%20office%20canteen%20during%20lunch%20break%2C%20warm%20sunlight%20through%20large%20windows%2C%20office%20workers%20talking%2C%20clean%20cheerful%20cinematic%20composition%20with%20orange%20accents&width=1600&height=900&seq=sigua-back-08&orientation=landscape',
    updatedAt: '2026-10-09',
  },
  {
    id: 'wind-of-gaogang',
    title: '岗顶的风',
    type: 'movie',
    year: 2023,
    region: '港台',
    rating: 8.5,
    popularity: 79,
    director: '蔡一鸣',
    cast: ['岑朗', '顾念', '谭亦'],
    genres: ['剧情', '运动'],
    episodes: '128 分钟',
    status: '已上线',
    summary:
      '一支快要解散的业余马拉松队，把训练场设在城市最陡的一段坡道上。教练是个只会说"再跑一次"的沉默老人，队员却在这句重复了上千遍的话里，跑回了各自丢掉的生活。',
    poster:
      'https://readdy.ai/api/search-image?query=Sports%20drama%20movie%20poster%20of%20runners%20climbing%20a%20steep%20city%20slope%20at%20dawn%2C%20silhouettes%20against%20warm%20orange%20sky%2C%20gritty%20inspiring%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Runners%20climbing%20a%20steep%20city%20slope%20at%20dawn%2C%20warm%20orange%20sky%20and%20long%20shadows%2C%20gritty%20cinematic%20sports%20film%20still%2C%20soft%20haze&width=1600&height=900&seq=sigua-back-09&orientation=landscape',
    updatedAt: '2026-10-08',
  },
  {
    id: 'rainy-palace',
    title: '雨落在旧宫',
    type: 'tv',
    year: 2023,
    region: '国产',
    rating: 8.3,
    popularity: 76,
    director: '汤衡',
    cast: ['凌书', '苏念安', '闻昭'],
    genres: ['古装', '悬疑'],
    episodes: '全 36 集',
    status: '完结',
    summary:
      '旧宫中的一场连雨，把一个年轻女官的过去冲了出来。她曾经以为自己只是替人抄书的无名小卒，直到发现整座宫殿的账册都出自她手。这是一段关于书写与权力的隐秘叙事。',
    poster:
      'https://readdy.ai/api/search-image?query=Historical%20mystery%20series%20poster%20of%20an%20ancient%20palace%20courtyard%20in%20heavy%20rain%2C%20lone%20figure%20with%20lantern%2C%20deep%20charcoal%20architecture%20with%20warm%20amber%20light%2C%20refined%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-10&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Ancient%20palace%20courtyard%20in%20heavy%20rain%20at%20night%2C%20stone%20path%20reflecting%20lantern%20light%2C%20warm%20amber%20glow%20on%20dark%20wood%2C%20cinematic%20historical%20film%20still&width=1600&height=900&seq=sigua-back-10&orientation=landscape',
    updatedAt: '2026-10-07',
  },
  {
    id: 'bake-a-song',
    title: '烤一首歌',
    type: 'variety',
    year: 2025,
    region: '国产',
    rating: 8.1,
    popularity: 84,
    director: '伍时',
    cast: ['黎可', '钟牧', '闻小舟'],
    genres: ['音乐', '真人秀'],
    episodes: '全 8 期',
    status: '完结',
    summary:
      '一间废弃面包房被改造成录音棚，音乐人必须在面包出炉的时间里写完一首完整的歌。面粉、黄油与旋律混在一起，诞生了八首关于早餐的奇怪又温柔的作品。',
    poster:
      'https://readdy.ai/api/search-image?query=Music%20variety%20show%20poster%20of%20a%20cozy%20bakery%20converted%20into%20a%20recording%20studio%2C%20warm%20bread%20and%20guitar%2C%20steaming%20oven%20light%2C%20cream%20and%20orange%20palette%2C%20inviting%20poster%20design&width=600&height=840&seq=sigua-poster-11&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20bakery%20converted%20into%20music%20recording%20studio%2C%20warm%20oven%20glow%2C%20guitar%20leaning%20on%20flour%20dust%20counter%2C%20homely%20cinematic%20lifestyle%20photography&width=1600&height=900&seq=sigua-back-11&orientation=landscape',
    updatedAt: '2026-10-06',
  },
  {
    id: 'north-sea-diver',
    title: '北海潜水员',
    type: 'movie',
    year: 2024,
    region: '日韩',
    rating: 8.6,
    popularity: 81,
    director: '高桥令',
    cast: ['森川凛', '井上透', '小林冬'],
    genres: ['冒险', '剧情'],
    episodes: '121 分钟',
    status: '已上线',
    summary:
      '退休潜水员在北海渔村发现了一艘沉睡四十年的沉船，船舱里的录音带还留着他年轻时搭档的声音。为了弄清那场事故的真相，他带着无人机与旧地图再次下水，与这片海做最后一次谈判。',
    poster:
      'https://readdy.ai/api/search-image?query=Adventure%20movie%20poster%20of%20a%20lone%20diver%20descending%20into%20deep%20cold%20northern%20sea%2C%20sunlight%20rays%20through%20water%2C%20wrecked%20ship%20silhouette%2C%20teal%20and%20amber%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-12&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Underwater%20scene%20of%20a%20diver%20approaching%20a%20sunken%20shipwreck%20in%20cold%20northern%20sea%2C%20god%20rays%20through%20water%2C%20amber%20highlight%20on%20rust%20metal%2C%20cinematic%20film%20still&width=1600&height=900&seq=sigua-back-12&orientation=landscape',
    updatedAt: '2026-10-05',
  },
  {
    id: 'dubai-shortcut',
    title: '沙漠里的捷径',
    type: 'movie',
    year: 2026,
    region: '欧美',
    rating: 7.9,
    popularity: 74,
    director: 'Elliot Marsh',
    cast: ['Noah Bennett', 'Clara Reyes', 'Tobias Lang'],
    genres: ['喜剧', '公路'],
    episodes: '105 分钟',
    status: '已上线',
    summary:
      '两个几乎互不相识的租车行员工，为了送一位迷路的老太太回家，开着一辆快要报废的货车横穿整片沙漠。一路上他们遇到的每个人都在讲同一个故事，只是结局各不相同。',
    poster:
      'https://readdy.ai/api/search-image?query=Road%20comedy%20movie%20poster%20of%20an%20old%20pickup%20truck%20on%20a%20desert%20highway%20at%20sunset%2C%20warm%20orange%20sand%20and%20long%20shadows%2C%20quirky%20minimal%20poster%20design%2C%20dry%20humor%20mood&width=600&height=840&seq=sigua-poster-13&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Old%20pickup%20truck%20driving%20on%20a%20desert%20highway%20at%20sunset%2C%20dust%20trail%2C%20warm%20orange%20sky%2C%20cinematic%20road%20movie%20still%20with%20soft%20haze&width=1600&height=900&seq=sigua-back-13&orientation=landscape',
    updatedAt: '2026-10-04',
  },
  {
    id: 'campus-siege',
    title: '雨季球场',
    type: 'tv',
    year: 2025,
    region: '国产',
    rating: 7.8,
    popularity: 71,
    director: '呼延澈',
    cast: ['程星野', '路遥', '苏格'],
    genres: ['青春', '运动'],
    episodes: '全 24 集',
    status: '完结',
    summary:
      '一所中学的篮球队在雨季里失去了球场，也失去了队长。剩下的队员把训练场搬到教学楼的天台，在连续的雨声与下课铃里，把一支不被看好的队伍重新拼起来。',
    poster:
      'https://readdy.ai/api/search-image?query=Youth%20sports%20series%20poster%20of%20high%20school%20basketball%20court%20in%20rain%2C%20wet%20orange%20jersey%2C%20moody%20blue%20gray%20sky%20with%20warm%20floodlight%2C%20energetic%20minimal%20poster&width=600&height=840&seq=sigua-poster-14&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=High%20school%20basketball%20court%20in%20heavy%20rain%20at%20dusk%2C%20wet%20asphalt%20reflecting%20warm%20floodlights%2C%20cinematic%20youth%20sports%20film%20still&width=1600&height=900&seq=sigua-back-14&orientation=landscape',
    updatedAt: '2026-10-03',
  },
  {
    id: 'silent-radio-show',
    title: '无声电台',
    type: 'variety',
    year: 2024,
    region: '国产',
    rating: 8.2,
    popularity: 77,
    director: '关槐',
    cast: ['夏柏', '罗一', '程未'],
    genres: ['访谈', '文化'],
    episodes: '全 10 期',
    status: '完结',
    summary:
      '每期节目只有一位嘉宾，一盏灯和一个没有信号的老式收音机。嘉宾需要在一小时内，把一件从未告诉别人的小事说成一段完整的广播剧。',
    poster:
      'https://readdy.ai/api/search-image?query=Interview%20show%20poster%20of%20a%20vintage%20radio%20in%20a%20dark%20room%20with%20single%20warm%20spotlight%2C%20microphone%20and%20chair%2C%20moody%20intimate%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Intimate%20dark%20studio%20with%20a%20vintage%20radio%2C%20microphone%20and%20single%20warm%20spotlight%20beam%2C%20dust%20in%20the%20air%2C%20cinematic%20portrait%20lighting&width=1600&height=900&seq=sigua-back-15&orientation=landscape',
    updatedAt: '2026-10-02',
  },
  {
    id: 'maple-and-rain',
    title: '枫与小雨',
    type: 'tv',
    year: 2022,
    region: '国产',
    rating: 8.4,
    popularity: 72,
    director: '乔知遇',
    cast: ['时小雨', '叶枫', '秦朗'],
    genres: ['治愈', '都市'],
    episodes: '全 30 集',
    status: '完结',
    summary:
      '两位合租的陌生人在城市里分别养了一只猫，一只叫枫，一只叫小雨。猫总是走丢，于是他们一次次敲开彼此的房门，也一次次走进彼此的生活。',
    poster:
      'https://readdy.ai/api/search-image?query=Healing%20urban%20drama%20series%20poster%20of%20two%20cats%20sitting%20in%20a%20warm%20lit%20apartment%20window%20with%20rain%20outside%2C%20maple%20leaves%2C%20soft%20orange%20light%2C%20gentle%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-16&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20city%20apartment%20window%20at%20evening%20with%20rain%20outside%2C%20two%20cats%20on%20the%20sill%2C%20soft%20orange%20lamp%20light%2C%20cinematic%20gentle%20mood&width=1600&height=900&seq=sigua-back-16&orientation=landscape',
    updatedAt: '2026-10-01',
  },
  {
    id: 'cliff-stage',
    title: '悬崖剧场',
    type: 'variety',
    year: 2023,
    region: '国产',
    rating: 7.7,
    popularity: 68,
    director: '雷墨',
    cast: ['安然', '许知', '唐沐'],
    genres: ['舞台', '竞技'],
    episodes: '全 6 期',
    status: '完结',
    summary:
      '在悬崖边搭起的露天剧场里，六组素人表演者用一周时间完成一场只演一次的戏。台下没有观众，只有风与海，和一直亮到天黑的灯。',
    poster:
      'https://readdy.ai/api/search-image?query=Theatrical%20competition%20poster%20of%20an%20open%20air%20stage%20on%20a%20cliff%20edge%20with%20warm%20spotlights%20against%20dark%20sea%2C%20dramatic%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-17&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Open%20air%20theatre%20stage%20on%20a%20cliff%20edge%20at%20dusk%2C%20warm%20spotlights%20and%20dark%20sea%20beyond%2C%20cinematic%20dramatic%20wide%20shot&width=1600&height=900&seq=sigua-back-17&orientation=landscape',
    updatedAt: '2026-09-30',
  },
  {
    id: 'factory-of-lights',
    title: '灯火工厂',
    type: 'movie',
    year: 2022,
    region: '港台',
    rating: 8.1,
    popularity: 66,
    director: '何家朗',
    cast: ['陈立行', '梁咏之', '黄宥'],
    genres: ['剧情', '历史'],
    episodes: '134 分钟',
    status: '已上线',
    summary:
      '一家老灯泡厂在最后一个生产日里，工人们决定把所有的灯都点亮一次。厂长在仓库深处找到一张五十年前的合影，照片上的人几乎都还在这间厂里。',
    poster:
      'https://readdy.ai/api/search-image?query=Historical%20drama%20movie%20poster%20of%20an%20old%20light%20bulb%20factory%20interior%20filled%20with%20glowing%20warm%20lamps%2C%20dusty%20industrial%20space%2C%20nostalgic%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-18&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Old%20light%20bulb%20factory%20interior%20filled%20with%20hundreds%20of%20glowing%20warm%20lamps%2C%20dusty%20industrial%20space%2C%20cinematic%20film%20still%20with%20golden%20light&width=1600&height=900&seq=sigua-back-18&orientation=landscape',
    updatedAt: '2026-09-28',
  },
  {
    id: 'stairway-orchestra',
    title: '楼梯交响曲',
    type: 'movie',
    year: 2026,
    region: '欧美',
    rating: 8.3,
    popularity: 88,
    director: 'Marta Iversen',
    cast: ['Iris Hall', 'Jonah Pell', 'Devon Achter'],
    genres: ['音乐', '剧情'],
    episodes: '118 分钟',
    status: '已上线',
    summary:
      '一支临时拼凑的街头乐队，把一座老楼的每一层楼梯当成一个声部。当整栋楼要拆掉时，他们决定用一场从一楼到顶层的演出，把这座楼最后的声音留住。',
    poster:
      'https://readdy.ai/api/search-image?query=Music%20drama%20movie%20poster%20of%20a%20brass%20band%20playing%20on%20a%20spiral%20staircase%20of%20an%20old%20building%2C%20warm%20amber%20light%20from%20windows%2C%20cinematic%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-19&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Street%20band%20playing%20on%20a%20spiral%20staircase%20inside%20an%20old%20building%2C%20warm%20amber%20light%20streaming%20through%20windows%2C%20cinematic%20music%20film%20still&width=1600&height=900&seq=sigua-back-19&orientation=landscape',
    updatedAt: '2026-09-26',
  },
  {
    id: 'midnight-grocery-team',
    title: '凌晨便利店队',
    type: 'tv',
    year: 2026,
    region: '日韩',
    rating: 7.6,
    popularity: 64,
    director: '中野俊',
    cast: ['小野真白', '加藤伊织', '三浦亮'],
    genres: ['喜剧', '日常'],
    episodes: '全 12 集',
    status: '更新至 4 集',
    summary:
      '三个夜班店员在凌晨两点到五点之间，处理过醉汉、走失的狗和一台会自动播放老歌的收银机。他们用最普通的对话，撑起了这座城市最安静的一段时间。',
    poster:
      'https://readdy.ai/api/search-image?query=Night%20shift%20convenience%20store%20comedy%20poster%20with%20warm%20interior%20light%20and%20glowing%20storefront%20sign%2C%20quiet%20empty%20street%2C%20cozy%20minimal%20poster%20design&width=600&height=840&seq=sigua-poster-20&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Convenience%20store%20interior%20at%203am%20with%20warm%20fluorescent%20light%2C%20quiet%20empty%20street%20outside%2C%20cinematic%20everyday%20life%20still%20with%20amber%20tones&width=1600&height=900&seq=sigua-back-20&orientation=landscape',
    updatedAt: '2026-09-24',
  },
];

export const featuredIds = [
  'night-train-to-mars',
  'oranges-in-the-snow',
  'slow-variety-kitchen',
  'seven-signals',
  'stairway-orchestra',
];

export const regions = ['全部', '国产', '港台', '日韩', '欧美'];

export const years = ['全部', 2026, 2025, 2024, 2023, 2022];

export const ratingOptions = [
  { label: '全部', value: 0 },
  { label: '9 分以上', value: 9 },
  { label: '8 分以上', value: 8 },
  { label: '7 分以上', value: 7 },
];